export const SLOTS_OVER_CAP_MESSAGE = 'Qtd. Slots não pode ultrapassar Qtd. Colunas × 5.';

export const maxSlotsForColumns = (columns) => (columns ?? 0) * 5;

export const isResourceQtyFieldHidden = (fieldAccess) => fieldAccess === 0;

export const isResourceQtyFieldDisabled = ({ fieldAccess, isInactive }) => {
  if (fieldAccess !== 2) {
    return true;
  }

  return Boolean(isInactive);
};

export const isResourceQtyBelowMin = (value) => value != null && value < 0;

export const isResourceQtyOverCap = (slots, columns) => {
  const normalizedColumns = columns ?? 0;
  const normalizedSlots = slots ?? 0;

  if (normalizedColumns <= 0) {
    return normalizedSlots > 0;
  }

  return normalizedSlots > maxSlotsForColumns(normalizedColumns);
};

export const validateResourceQtySlots = (slotsValue, columns) => {
  if (isResourceQtyBelowMin(slotsValue) || isResourceQtyBelowMin(columns)) {
    return 'Valor mínimo é 0.';
  }

  if (isResourceQtyOverCap(slotsValue, columns)) {
    return SLOTS_OVER_CAP_MESSAGE;
  }

  return null;
};
